import React from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  IconButton,
  Paper,
} from '@mui/material';
import { motion } from 'framer-motion';
import {
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
  Twitter as TwitterIcon,
  Email as EmailIcon,
} from '@mui/icons-material';

const Contact: React.FC = () => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // Handle form submission here
  };

  return (
    <Box sx={{ py: 8, minHeight: '100vh' }}>
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h2" component="h1" gutterBottom>
            Get in Touch
          </Typography>
          <Typography variant="h5" color="text.secondary" paragraph>
            Have a question or want to work together? Feel free to reach out!
          </Typography>

          <Grid container spacing={4} sx={{ mt: 4 }}>
            <Grid item xs={12} md={6}>
              <Paper
                elevation={3}
                sx={{
                  p: 4,
                  background: 'rgba(255, 255, 255, 0.05)',
                }}
              >
                <form onSubmit={handleSubmit}>
                  <TextField
                    fullWidth
                    label="Name"
                    variant="outlined"
                    margin="normal"
                    required
                  />
                  <TextField
                    fullWidth
                    label="Email"
                    type="email"
                    variant="outlined"
                    margin="normal"
                    required
                  />
                  <TextField
                    fullWidth
                    label="Message"
                    multiline
                    rows={4}
                    variant="outlined"
                    margin="normal"
                    required
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{ mt: 2 }}
                  >
                    Send Message
                  </Button>
                </form>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper
                elevation={3}
                sx={{
                  p: 4,
                  height: '100%',
                  background: 'rgba(255, 255, 255, 0.05)',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Typography variant="h5" gutterBottom>
                  Connect with me
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                  {/* <IconButton
                    color="primary"
                    href="https://github.com/yourusername"
                    target="_blank"
                    size="large"
                  >
                    <GitHubIcon />
                  </IconButton> */}
                  <IconButton
                    color="primary"
                    href="https://www.linkedin.com/in/mohsinahmed084/"
                    target="_blank"
                    size="large"
                  >
                    <LinkedInIcon />
                  </IconButton>
                  <IconButton
                    color="primary"
                    href="https://x.com/Mohsin_ggn08"
                    target="_blank"
                    size="large"
                  >
                    <TwitterIcon />
                  </IconButton>
                  <IconButton
                    color="primary"
                    href="mailto:soft.mohsin@gmail.com"
                    size="large"
                  >
                    <EmailIcon />
                  </IconButton>
                </Box>
                <Typography variant="body1" sx={{ mt: 4 }}>
                  Based in Singapore
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Available for freelance work and full-time positions
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Contact; 